import styled from 'astroturf/react';
import FieldBase from 'src/components/Field';

const Wrapper = styled('div')`
  display: block;
`;

const Box = styled('div')`
  display: flex;
`;

const PageA4Header = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  width: 18.5cm;
  height: 1.5cm;
  border-bottom: 2px solid gray;
  margin: 1.25cm 1.25cm 0 1.25cm;

  div[class*="logo-wrapper"] {
    height: 30px;
    position: absolute;
    left: 20px;
  }

  div[class*="evt-links"] {
    display: inline-block;
    width: 50%;
    text-align: right;

    div[class*="website"] {
      color: var(--ph-gray-500);
    }

    a {
      text-decoration: underline;
      pointer-events: none;
    }
  }
`;

const PageA4Footer = styled('div')`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18.5cm;
  height: 1.5cm;
  border-top: 2px solid gray;
  margin: 0 1.25cm 1.25cm 1.25cm;
`;

const FooterDateText = styled('div')`
  position: absolute;
  bottom: 0.5cm;
  left: 0;
`;

const PageNumber = styled('div')`
  position: absolute;
  bottom: 0.5cm;
  right: 0;
`;

const PageWrapper = styled('div')`
  background: rgb(204, 204, 204);
  padding-top: 40px;
  padding-bottom: 40px;
`;

const PageA4 = styled('div')`
  font-family: Arial, serif;
  position: relative;
  background: white;
  display: block;
  margin: 0 auto 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  width: 21cm;
  height: 29.7cm;
  padding: 1.25cm;
`;

const PageA4Inner = styled('div')`
  padding-top: 1.5cm;
  width: 100%;
  height: 100%;

  &.justify {
    text-align: justify;
  }
`;

const ImageWrapper = styled('ul')`
  margin: 0 -0.1cm;
  padding: 0;

  li[class*="image-preview"] {
    display: inline-block;
    width: 6.21cm;
    height: 5.75cm;
    padding: 0.1cm;
    box-sizing: border-box;
    vertical-align: top;

    div[class*="image-outer"] {
      height: 4.25cm;
      background-color: var(--ph-gray-50);

      img {
        display: block;
        height: 4.25cm;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        padding: 0;
        pointer-events: none;
      }
    }

    span {
      height: 1.5cm;
      background-color: var(--ph-gray-50);
      display: inline-block;
      width: 100%;
      margin: 0;
      padding: 0.1cm;

      &.finding {
        color: var(--ph-red-700);
      }
    }
  }
`;

const Caption = styled('span')`
  height: 2cm;
  background-color: var(--ph-gray-50);
  display: inline-block;
  width: 100%;
  margin: 0;
  line-height: 16px;
  font-family: Arial;
  font-size: 10pt;
  font-weight: normal;
  border-top: 0.1cm solid var(--white);
  border-bottom: 0.1cm solid var(--white);

  &.finding {
    color: var(--ph-red-500);
  }
`;

const Fields = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  page-break-inside: avoid;
  break-inside: avoid;
`;

const Field = styled(FieldBase)`
  flex: 50%;
  padding: 1px 0;
  margin-bottom: 0;
  margin-right: 2px;
  max-width: calc(50% - 2px);

  div[class*="FieldLabel"] {
    font-family: Arial;
    font-size: 10pt;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 30px;
    letter-spacing: normal;
    color: var(--black);
    position: relative;
    background-color: #A4F8D8;
    padding: 5px;
    justify-content: flex-end;
  }

  div[class*="FieldText"] {
    width: 100%;
    display: flex;
    font-family: Arial;
    font-size: 10pt;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 30px;
    letter-spacing: normal;
    color: var(--black);
    background-color: var(--ph-gray-50);
    padding: 5px;
    justify-content: flex-start;
  }
`;

const Title = styled('h1')`
  font-size: 18pt !important;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  color: var(--black);
  margin: auto !important;
  margin-bottom: 1cm !important;
  margin-top: 0.67em !important;
`;

const SectionTitle = styled('h1')`
font-family: Arial;
font-size: 10pt !important;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: normal;
white-space: normal;
text-align: center;
color: var(--black);
margin: auto !important;
margin-top: 0px;
margin-bottom: 5px !important;
text-align: left;
background-color: #0FF2B2;
padding: 8px 10px;

  &.withBreak {
    page-break-before: always;
  }
`;

const PhotoSectionUpperText = styled('p')`
  font-family: Arial;
  font-size: 10pt;
  font-weight: normal;
  line-height: initial;
`;

export default {
  Box,
  Caption,
  Field,
  Fields,
  FooterDateText,
  ImageWrapper,
  PageWrapper,
  PageA4,
  PageA4Footer,
  PageA4Header,
  PageA4Inner,
  PageNumber,
  PhotoSectionUpperText,
  SectionTitle,
  Title,
  Wrapper,
};
